//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment from 'moment';
import { getAction, httpAction } from '@api/manage';
export default {
  name: 'VerificationReport',
  mixins: [GetSiteIdMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/om/reagent/verification/report',
      pageTitle: '核查周报',
      moment: moment,
      queryParam: {},
      siteName: '',
      siteId: '',
      scoped: '',
      reportList: [],
      factorMsgVos: [],
      reagentVerificationItemList: []
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(ids, ids);
      this.scoped = ids[0];

      if (ids[0] == 1) {
        this.siteName = this.currentSiteName;
        this.siteId = ids[1];
        this.getSiteReport();
      }
    }
  },
  created: function created() {
    this.queryParam.verificationDateStart = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
    this.queryParam.verificationDateEnd = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD');
  },
  computed: {},
  methods: {
    handleExportWord: function handleExportWord() {
      var _this = this;

      this.queryParam['siteId'] = this.siteId;
      httpAction('/om/reagent/verification/export/word', this.queryParam, 'post').then(function (res) {
        if (res) {
          var filename = _this.siteName + '周报.doc';
          var blob = new Blob([res], {
            type: 'application/msword;charset=utf-8'
          });
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = filename;
          var body = document.getElementsByTagName('body')[0];
          body.appendChild(a);
          a.click();
          body.removeChild(a);
          window.URL.revokeObjectURL(url);

          _this.$message_custom('生成word成功');
        } else {
          _this.$message_custom('系统异常', 'warning');
        }
      });
    },
    onDateChange: function onDateChange(value, dateString) {
      console.log(dateString[0], dateString[1]);
      this.queryParam.verificationDateStart = dateString[0];
      this.queryParam.verificationDateEnd = dateString[1]; // this.getSiteReport()
    },
    onDateOk: function onDateOk(value) {
      console.log(value);
    },
    getSiteReport: function getSiteReport() {
      var _this2 = this;

      this.queryParam['siteId'] = this.siteId;
      getAction(this.pagePath, this.queryParam).then(function (res) {
        if (res.success) {
          _this2.reportList = res.result;
          _this2.reagentVerificationItemList = res.result.reagentVerificationItemList;
          _this2.factorMsgVos = res.result.factorMsgVos;
        }
      });
    },
    searchQuery: function searchQuery() {
      this.getSiteReport();
    }
  }
};